import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput,
  Button,
  Spinner
} from "flowbite-react";
import {ArrowRight,ArrowLeft} from "lucide-react"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import moment from 'moment';
import 'moment/locale/fr';  // Import French locale if you want dates in French
const PDVPage = () => {
  const [pdv, setPdv] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPdv, setTotalPdv] = useState(0);
  const [limit] = useState(10);
  const navigate = useNavigate()
  const fetchPdv = async (page = 1, search = "") => {
    try {
        setLoading(true);
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}getAllPDVsByFranchise/?page=${page}&limit=${limit}&search=${search}`,
            { withCredentials: true }
        );
        setPdv(response.data.data);
        setTotalPages(response.data.totalPages);
        setCurrentPage(response.data.currentPage);
        setTotalPdv(response.data.total);
        setLoading(false);
    } catch (error) {
        console.log(error);
        setLoading(false);
    }
  };
  
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };
  
  const formatDate = (date) => {
    if (!date) return "N/A"; 
    return moment(date).format('DD/MM/YYYY HH:mm');
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
        fetchPdv(currentPage, searchTerm);
    }, 500);
  
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, currentPage,navigate]);
  
  console.log(pdv)
    return (
      <section className=" dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
              <div className="grid w-full grid-cols-1">
          <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
            <div className="w-full sm:w-1/2 p-2">
              <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                Mes Points de Vente
              </span>
            </div>
            <div className="w-full sm:w-1/2 p-2">
                                  <TextInput
                                      type="text"
                                      placeholder="Rechercher..."
                                      value={searchTerm}
                                      onChange={handleSearch}
                                  />
                              </div>
          </div>
              </div>
              <div className="overflow-x-auto rounded-md">
              <Table striped>
              <TableHead>
                
                  <TableHeadCell>Propriétaire PDV</TableHeadCell>
                  <TableHeadCell>Nom</TableHeadCell>
                  <TableHeadCell>Prénom</TableHeadCell>
                  <TableHeadCell>Statut du compte</TableHeadCell>
                  <TableHeadCell>Franchise</TableHeadCell>
                  <TableHeadCell>Franchise owner</TableHeadCell>
                  <TableHeadCell>gouvernorat Franchise</TableHeadCell>
                  <TableHeadCell>Date de création</TableHeadCell>
                  
                  
              </TableHead>
              
              <TableBody className="divide-y">
                  {pdv?.length ? pdv?.map((pdv, index) => (
                  <TableRow key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300"
                    onClick={()=> navigate(`/pdvPage`,{state:{pdv_id:pdv?._id}})}
                  >
                      <TableCell className="font-bold">{pdv?.owner}</TableCell>
                      <TableCell className="font-bold">{pdv?.pos_agent_id?.first_name}</TableCell>
                      <TableCell className="font-bold">{pdv?.pos_agent_id?.last_name}</TableCell>
                      <TableCell >{pdv?.pos_agent_id?.user?.account_status}</TableCell>
                      <TableCell>{pdv?.franchise_id?.pos_franchise_id?.name}</TableCell>
                      <TableCell>{pdv?.franchise_id?.pos_franchise_id?.owner}</TableCell>
                      <TableCell>{pdv?.franchise_id?.pos_franchise_id?.gouvernorat}</TableCell>
                      <TableCell>{formatDate(pdv?.pos_agent_id?.created_at)}</TableCell>
                     
                  </TableRow>
                  )) : 
                  <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300">
                      <TableCell> {loading ? <Spinner/> : "Aucune PDV trouvée ."}</TableCell>
                      
                  </TableRow>
                  }
              </TableBody> 
              </Table>
              </div>
              <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
              <div className="flex justify-center items-center gap-2">
                          <Button
                             disabled={currentPage === 1 || totalPages === 0}
                              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                              color = {"dark"}
                              size="xs"
                          >
                              <ArrowLeft size={16} /> 
                          </Button>
                          <span className="self-center">
                              Page {currentPage} / {totalPages}
                          </span>
                          <Button
                              disabled={currentPage === totalPages || totalPages === 0}
                              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                              color = {"dark"}
                              size="xs"
                          >
                              <ArrowRight size={16} />
                          </Button>
              </div>
              <div>
                <span>Total : {totalPdv}</span>
              </div>
              </section>
      </section> 
    );
  };

export default PDVPage